<div class="d-flex justify-content-center align-items-center flex-column h-100vh banner">
    <div #air id="air" class='air kenburns-top'></div>
    <h1 class="main-heading">{{"Knowledge gate" | translator}}</h1>
    <p class="mini-heading">{{"Knowledge" | translator}} | {{"Training" | translator}} | {{"Development" | translator}} </p>
    <div class="v4-login-card p-4 w-full lg:w-6">
        <div class="text-center mb-1">
            <img src="/assets/img/logo/sbclogo.svg" alt="Image" height="50" class="mb-3">
        </div>
        <h3 class="sstarabicbold text-center pcolor pb-2">{{"Your account has been activated" | translator}}</h3>
        <p *ngIf="message" style="color: red;" class="text-center error"> {{message | translator}}</p>
        <div>
            <div class="col-xs-12 form-group text-right">
                <button [disabled]="!canLogin" type="button" (click)="login()"
                     class="w-full v4-btn-every py-2"><i class="pi pi-key v4-ml-2"></i>{{"sign in" | translator}}</button>
            </div>
        </div>
    </div>
</div>